export default __webpack_public_path__ + "static/media/home-hero-600.790483f5.svg";